module.exports = __webpack_public_path__ + "img/bg2.4ebcf8b2.jpg";